import { computedFrom } from "aurelia-framework";
import * as moment from "moment";
import * as momentTimeZone from "moment-timezone";
import { BaseEntity } from "../base-entity";
import { IEntityTypeIdentifier } from "@rightship-tech/common-ui/models/basic.models";

export abstract class BaseOfficeTime {

    get londonTime() {
        return this.getTimeFromTimeZone("Europe/London");
    }

    get melbourneTime() {
        return this.getTimeFromTimeZone("Australia/Melbourne");
    }

    get houstonTime() {
        return this.getTimeFromTimeZone("America/Monterrey");
    }
    
    getTimeFromTimeZone(timeZone: string) {
        return momentTimeZone().tz(timeZone).format("LT");
    }
}

export abstract class BaseOfficeTimeBaseEntity<T extends IEntityTypeIdentifier> extends BaseEntity<T> {

        get londonTime() {
        return this.getTimeFromTimeZone("Europe/London");
    }

    get melbourneTime() {
        return this.getTimeFromTimeZone("Australia/Melbourne");
    }

    get houstonTime() {
        return this.getTimeFromTimeZone("America/Monterrey");
    }

    @computedFrom('londonTime')
    get isLondonOpen() {
        return this.isOfficeOpen("Europe/London", 9, 17, [6, 0]);
    }

    @computedFrom('melbourneTime')
    get isMelbourneOpen() {
        return this.isOfficeOpen("Australia/Melbourne", 9, 17, [6, 0]);
    }

    @computedFrom('houstonTime')
    get isHoustonOpen() {
        return this.isOfficeOpen("America/Monterrey", 9, 17, [6, 0]);
    }

    getTimeFromTimeZone(timeZone: string) {
        return momentTimeZone().tz(timeZone).format("LT");
    }

    isOfficeOpen(timeZone: string, hourOpen: number, hourClosed: number, closedDaysOfTheWeek: number[]) {
        const timeNow = momentTimeZone().tz(timeZone);
        const timeOpen = moment(timeNow).hour(hourOpen).minute(0).second(0);
        const timeClosed = moment(timeNow).hour(hourClosed).minute(0).second(0);

        const isWholeDayOff = closedDaysOfTheWeek.indexOf(timeNow.day()) > -1;

        if (!isWholeDayOff && (timeOpen <= timeNow && timeClosed > timeNow)) {
            return true;
        }

        return false;
    }
}